import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        padding: '2rem 0 1rem 0',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        height: '100%'
    },
    content: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '0',
        flexGrow: 1
    },
    textFilterContainer: {
        borderBottom: '1px solid #D5D5D5',
        padding: '0 2.5rem'
    },
    dateFilterContainer: { borderBottom: '1px solid #D5D5D5' },
    dateRangeSelectorContainer: { borderRight: '1px solid #d3d3d3' },
    filtersContainer: { width: 'auto' as const },
    filterOption: {
        padding: '.3rem',
        fontSize: '.8rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        marginLeft: '.75rem',
        cursor: 'pointer' as const,
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHoverLight ||
                '#bec6d470'
        }
    },
    realtimeTag: {
        fontSize: '.8rem',
        marginLeft: '2rem'
    },
    realtimeState: {
        padding: '.4rem',
        marginLeft: '.6rem',
        borderRadius: '3px',
        fontWeight: 'bold' as const
    },
    realtimeEnabled: {
        color: theme?.app?.applicationColors.successDark ||
            '#5AAC01',
        backgroundColor: theme?.app?.applicationColors.successOpaque ||
            '#5AAC011A'
    },
    realtimeDisabled: {
        color: theme?.app?.applicationColors.failure ||
            '#FA5252',
        backgroundColor: theme?.app?.applicationColors.failureOpaque ||
            '#FA52521A'
    },
    exportButton: {
        alignSelf: 'flex-end' as const,
        marginLeft: '1rem',
        marginBottom: '.5rem'
    },
    exportIcon: {
        height: '16px',
        width: '24px'
    },
    transactionFilter: {
        fontSize: '1rem',
        lineHeight: '2rem',
        cursor: 'pointer' as const,
        color: theme?.app?.applicationColors.enumColors.grey ||
            '#888888',
        padding: '0 .75rem',
        marginRight: '2.5rem',
        '&:last-child': { marginRight: 0 }
    },
    selectedTransactionFilter: {
        color: theme?.app?.applicationColors.fontDetailColor ||
            '#4A4C50',
        borderBottom: `3px solid ${theme?.app?.clientTheme.colors.highlightColor3 ||
        '#B9D9EC'}`
    },
    tassatPayLogo: { width: '8.5rem' }
});